module.exports = __webpack_public_path__ + "img/pet-passport_B09T5LCNRL.3fa5e919.jpg";